import React from 'react'
import { IShape } from '..'
import { shapeSizes } from './Shape'

export const Semicircle = ({ className, size, color }: IShape): React.ReactElement => {
  return (
    <svg
      className={className}
      width="1440"
      height={shapeSizes[size]}
      viewBox="0 0 1440 84"
      fill="none"
      preserveAspectRatio="none"
    >
      <path d="M0 83C454.33-24.774 928.696-27.898 1384.99 71.96L1440 83v2H0Z" fill={color} />
    </svg>
  )
}
